import Vuex from 'vuex'
import Vue from 'vue'
import api from 'networks/api/api.js'

const WHITE_LIST = ['subpages/redirect']
Vue.use(Vuex)
const store = new Vuex.Store({
	state:{
		"userInfo":  {
			"userId": "",
			"mpOpenId": "",
			"openId": "",
			"unionId": "",
			"avatar": "",
			"nickName": "",
			"phone": "",
			"wxNumber": "",
			"identityType": 0,
			"isMember": 0,
			"memberStartTime": "",
			"memberEndTime": "",
			"createTime": "",
			"isDistributor": null,
			"hasQuantify": 0
	},
		"tableCondition": {}
	},
	mutations: {
		set(state, userInfo) {
			state.userInfo = userInfo
			const tableCondition = uni.getStorageSync(`${userInfo.userId}:tableCondition`)
			if (tableCondition) {
				state.tableCondition = tableCondition
			}
		},
		setCondition(state, data) {
			const {tableName, condition} = data
			state.tableCondition[`${tableName}`] = condition
			uni.setStorageSync(`${state.userInfo.userId}:tableCondition`, state.tableCondition)
		}
	},
	actions: {

		async setUserInfo(context) {
			// 白名单内的url不获取用户信息
			if (WHITE_LIST.some(item => window.location.href.includes(item))) return
			const userInfo = await api.getUserInfo()
			context.commit('set', userInfo)
		},






		setTableCondition(context, data) {
			const {tableName, condition} = data
			context.commit('setCondition', {tableName, condition})
		}
	}
})

export default store